var React = require('react');

function AllPlatforms (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"48","height":"48","rx":"24","fill":"white","fillOpacity":"0.1","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16 16H20V20H16V16ZM16 22H20V26H16V22ZM20 28H16V32H20V28ZM22 16H26V20H22V16ZM26 22H22V26H26V22ZM22 28H26V32H22V28ZM32 16H28V20H32V16ZM28 22H32V26H28V22ZM32 28H28V32H32V28Z","fill":"white","fillOpacity":"0.8","key":1})]);
}

AllPlatforms.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = AllPlatforms;

AllPlatforms.default = AllPlatforms;
